export enum AnalysisType {
  'PORTAL_START' = 1, // welcome page
  'PORTAL_JOBS' = 2, // jobs page first tab
  'PORTAL_JOBS_CATALOG' = 3, // jobs page second tab
  'PORTAL_JOBS_EDUCATION' = 4, // jobs page Ausbildung tab
  'PORTAL_JOBS_LOCATION' = 5, // jobs page orte tab
  'PORTAL_JOBS_FIRMS' = 6, // jobs page Company tab
  'PORTAL_JOBS_MAP' = 7, // jobs page map tab
  'PORTAL_PERSONAL' = 8, // skilledview first tab
  'PORTAL_PERSONAL_CATALOG' = 9, // skilledview second tab
  'PORTAL_KURSES' = 10, // coursesview first tab
  'PORTAL_KURSES_CATALOG' = 11, // coursesview second tab
  'PORTAL_APPLICANT_LOGIN_COUNT' = 12, // LoginApplicant action success in user store
  'PORTAL_FIRM_LOGIN_COUNT' = 13, // LoginCompany action success in user store
  'PORTAL_SUPPORT_LOGIN_COUNT' = 14, // LoginConsultant action success in user store
}
